export default __webpack_public_path__ + "images/0x6e84a6216ea6dacc71ee8e6b0a5b7322eebc0fdd.png";